/**
 * @format
 */
declare global {
   interface Window {
      __theme: any;
   }
}
import { Injectable } from "@angular/core";

@Injectable()
export class CustomThemeService {
   constructor() {}

   setTheme(theme: "bs3" | "bs4"): void {
      if (Boolean(window)) {
         window.__theme = theme;
      }
   }
}
